// extracted by mini-css-extract-plugin
export default {"input":"InputCore_input__El93w"};